module.exports = __webpack_public_path__ + "static/media/satellite.5dae729e.png";